import React, { useState, useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { DummyRightCard } from "./DummyRightCard";

import { TourProvider, useTour } from "../User/TourContext";
import GuidedTour from "../User/GuidedTour";
import { vivaTourSteps } from "../User/tourSteps";

function CompetitiveContent() {

    const ee_id = 1;

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [questionStatus, setQuestionStatus] = useState({});
    const [isRecording, setIsRecording] = useState(false);
    const [stream, setStream] = useState(null);
    const [audioStream, setAudioStream] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const { run, stepIndex, setStepIndex, startTour, setRun } = useTour();

    useEffect(() => {
        if (location.state?.fromDemo === true && !run) {
            startTour();
            setStepIndex(0);
            navigate("", { replace: true, state: {} });
        }
    }, [location.state, run, startTour, setStepIndex, navigate]);
    useEffect(() => {
        // Optional: save current step when changing
        sessionStorage.setItem("tourStep", stepIndex.toString());
    }, [stepIndex]);
    useEffect(() => {
        // Try to resume tour from location state
        if (location.state?.resumeTour) {
            setStepIndex(location.state.stepIndex || 0);
            setRun(true);
        }
    }, [location.state]);
    // In both pages (e.g. InstructionsPage.jsx and DummyVivaExam.jsx)
   useEffect(() => {
  const params = new URLSearchParams(location.search);
  const tourStepParam = params.get("tourStep");

  if (tourStepParam !== null) {
    const targetStep = Number(tourStepParam);
    if (!isNaN(targetStep) && targetStep >= 0 && targetStep < vivaTourSteps.length) {
      setStepIndex(targetStep);
    }
    navigate(location.pathname, { replace: true });
  }
}, [location.search, navigate, setStepIndex, vivaTourSteps.length]);


    return (
        <Box>
            <section style={{ height: "700px", width: "1490px" }}>

                {ee_id ? (
                    <DummyRightCard
                        ee_id={ee_id}
                        currentQuestion={currentQuestion}
                        setCurrentQuestion={setCurrentQuestion}
                        questionStatus={questionStatus}
                        setQuestionStatus={setQuestionStatus}
                        isRecording={isRecording}
                        setIsRecording={setIsRecording}
                        stream={stream}
                        setStream={setStream}
                        audioStream={audioStream}
                        setAudioStream={setAudioStream}
                        showPopup={showPopup}
                        setShowPopup={setShowPopup}
                    />
                ) : (
                    <Box>
                        <CircularProgress />
                        <Typography>Loading...</Typography>
                    </Box>
                )}

                {run && (
                    <GuidedTour
                        steps={vivaTourSteps}
                        stepIndex={stepIndex}
                        setStepIndex={setStepIndex}
                        onFinish={() => setRun(false)}
                    />
                )}

            </section>
        </Box>
    );
}

export default CompetitiveContent;

